// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__zIZpu","footer":"ModalFilter_footer__31QqD"};